/* Subscribe to a subset of the available Worker.js events */

function registerTaskRouterCallbacks() {
    worker.on('ready', function (worker) {
        console.log('registerTaskRouterCallbacks ready');
        if (worker.activityName == 'Busy') {
            console.log('registerTaskRouterCallbacks ready: Status was Busy. Disconnecting all active calls and changing status to Available');
            Twilio.Device.disconnectAll();
            changeWorkerActivityStatus('Idle', function() {
                popup(worker.activityName);
                window.currentActivity = worker.activityName;
                agentActivityChanged(worker.activityName);
                logger("Successfully registered as: " + worker.friendlyName)
                logger("Current activity is: " + worker.activityName);
            });
        } else {
            popup(worker.activityName);
            window.currentActivity = worker.activityName;
            agentActivityChanged(worker.activityName);
            logger("Successfully registered as: " + worker.friendlyName)
            logger("Current activity is: " + worker.activityName);
        }
    });

    worker.on('activity.update', function (worker) {

        if (window.conferencePhoneTransfer >= 1) {
            console.log('conferencePhoneTransfer: true');
            console.log('registerTaskRouterCallbacks activity.update: ' + worker.activityName);
            if (worker.activityName == 'WrapUp') {
                console.log('change status back to busy');
                changeWorkerActivityStatus('Busy', function() {});
            }
            window.currentActivity = worker.activityName;
            return;
        }

        console.log('conferencePhoneTransfer: false');
        console.log('registerTaskRouterCallbacks activity.update: ' + worker.activityName);

        window.currentActivity = worker.activityName;

        agentActivityChanged(worker.activityName);
        popup(worker.activityName);

        if (worker.activityName == 'WrapUp') {
            setTimeout(changeWorkerAvailable, 20000);
        }

        logger("Worker activity changed to: " + worker.activityName);
    });

    worker.on("reservation.created", function (reservation) {
        console.log('registerTaskRouterCallbacks reservation.created: ' + JSON.stringify(reservation));
        updatePopup(reservation.task.attributes);
        logger("-----");
        logger("You have been reserved to handle a call!");
        logger("Call from: " + reservation.task.attributes.from);
        logger("Caller Name: " + (reservation.task.attributes.caller_name ? reservation.task.attributes.caller_name : 'N/A'));
        logger("selected task type: " + reservation.task.attributes.selected_task_type);
        logger("-----");
    });

    worker.on("reservation.accepted", function (reservation) {
        console.log('registerTaskRouterCallbacks reservation.accepted: ' + JSON.stringify(reservation));
        logger("Reservation " + reservation.sid + " accepted!");
        $('.wrapup > .change-activity').hide();
        $('#caller_id').text(reservation.task.attributes.from);
        $('#call_sid').val(reservation.task.attributes.call_sid);
        $('.feedback').show();
        $('.transfer-call-btn').show();
    });

    worker.on("reservation.rejected", function (reservation) {
        console.log('registerTaskRouterCallbacks reservation.rejected: ' + JSON.stringify(reservation));
        popup('close-popup');
        logger("Reservation " + reservation.sid + " rejected!");
    });

    worker.on("reservation.timeout", function (reservation) {
        console.log('registerTaskRouterCallbacks reservation.timeout: ' + JSON.stringify(reservation));
        popup('close-popup');
        logger("Reservation " + reservation.sid + " timed out!");
    });

    worker.on("reservation.canceled", function (reservation) {
        console.log('registerTaskRouterCallbacks reservation.canceled: ' + JSON.stringify(reservation));
        popup('close-popup');
        logger("Reservation " + reservation.sid + " canceled!");
    });
}

function changeWorkerAvailable() {

    changeWorkerActivityStatus('Idle', function() {
        $('.feedback').hide();
    });

    // var activitySids = {};
    // worker.activities.fetch(function (error, activityList) {
    //     var activities = activityList.data;
    //     var i = activities.length;
    //     while (i--) {
    //         activitySids[activities[i].friendlyName] = activities[i].sid;
    //     }
    //
    //     $('.feedback').hide();
    //     worker.update("ActivitySid", activitySids['Idle']);
    // });
}

/* Hook up the agent Activity buttons to Worker.js */

function bindAgentActivityButtons() {
    // Fetch the full list of available Activities from TaskRouter. Store each
    // ActivitySid against the matching Friendly Name

    // var activitySids = {};
    // worker.activities.fetch(function (error, activityList) {
    //     var activities = activityList.data;
    //     var i = activities.length;
    //     while (i--) {
    //         activitySids[activities[i].friendlyName] = activities[i].sid;
    //     }
    // });

    /* For each button of class 'change-activity' in our Agent UI, look up the
     ActivitySid corresponding to the Friendly Name in the button’s next-activity
     data attribute. Use Worker.js to transition the agent to that ActivitySid
     when the button is clicked.*/
    var elements = document.getElementsByClassName('change-activity');
    var i = elements.length;
    while (i--) {
        elements[i].onclick = function () {
            var nextActivity = this.dataset.nextActivity;
            //Check if status offline and add entry to activity record
            if ($('.dropdown-content').length !== 0 && nextActivity == 'Offline') {
                $('.dropdown-content').show();
                //$('#resDropdown').on('click','a',function(e){
                $("a.resDropdownClass").unbind().click(function () {
                    var res_id = $(this).attr('data-seq'); //get reason id
                    if (res_id) {
                        $('#offline-reason-notes').modal('show');
                        $('#offline-reason-notes #off_reason_id').val(res_id);
                        $('#extra-notes').val('');
                        $('#offline-reason-notes .extra-notes-add-btn').unbind().click(function () {
                            $.ajax({
                                type: 'POST',
                                url: '/activity/save-activity',
                                data: {
                                    resId: $('#off_reason_id').val(),
                                    extraNotes: $('#extra-notes').val(),
                                    actAction: 'offline',

                                },
                                success: function (data) {
                                    if (data == 1) {
                                        $('#offline-reason-notes').modal('hide');

                                        //var nextActivitySid = activitySids[nextActivity];
                                        //worker.update("ActivitySid", nextActivitySid);

                                        changeWorkerActivityStatus(nextActivity, function() {});
                                    } else {
                                        alert('Some error occurred. Please check.');
                                    }
                                },
                                error: function (data) {
                                    console.log(data.responseJSON);
                                    alert('Some error occurred. Please check.');
                                }
                            });
                        });
                    }
                });
            } else if (nextActivity == 'Idle') {
                $('.dropdown-content').hide();
                $.ajax({
                    type: 'POST',
                    url: '/activity/save-activity',
                    data: {
                        actAction: 'available',
                    },
                    success: function (data) {
                        if (data == 1) {
                            //var nextActivitySid = activitySids[nextActivity];
                            //worker.update("ActivitySid", nextActivitySid);

                            changeWorkerActivityStatus(nextActivity, function() {});
                        } else {
                            alert('Some error occurred. Please check.');
                        }
                    },
                    error: function (data) {
                        console.log(data.responseJSON);
                        alert('Some error occurred. Please check.');
                    }
                });
            } else {
                //var nextActivitySid = activitySids[nextActivity];
                //worker.update("ActivitySid", nextActivitySid);

                changeWorkerActivityStatus(nextActivity, function() {});
            }
        }
    }
}

/* Update the UI to reflect a change in Activity */

function agentActivityChanged(activity) {
    hideAgentActivities();
    showAgentActivity(activity);
}

function hideAgentActivities() {
    var elements = document.getElementsByClassName('agent-activity');
    var i = elements.length;
    while (i--) {
        elements[i].style.display = 'none';
    }
}

function showAgentActivity(activity) {
    activity = activity.toLowerCase();
    var elements = document.getElementsByClassName(('agent-activity ' + activity));
    elements.item(0).style.display = 'block';
}

/* Other stuff */

function logger(message) {
    var log = document.getElementById('log');
    log.value += "\n> " + message;
    log.scrollTop = log.scrollHeight;
}

function popup(activity) {

    console.log("Popup: " + activity);

    if (!activity) {
        return;
    }

    activity = activity.toLowerCase();

    if (activity == 'reserved') {
        $('#call-popup .modal-body .status').hide();
        $('#call-popup .modal-body .alert-warning').show();
        $('#call-popup .modal-body li span.text').empty();
        $('#call-popup .modal-body li img').show();
        $('#call-popup').modal('show');

        if (
            (typeof document.hidden !== "undefined" && document.hidden)
            || (typeof document.webkitHidden !== "undefined" && document.webkitHidden )
            || (typeof document.msHidden !== "undefined" && document.msHidden)
        ) {
            alert('You have received a call!. Press OK immediately to continue!');
        }
    }

    if (activity == 'busy') {
        $('#call-popup .modal-body .status').hide();
        $('#call-popup .modal-body .alert-danger').show();
    }

    if (activity == 'open-popup') {
        $('#call-popup').modal('show');
    }

    if (activity == 'wrapup' || activity == 'idle' || activity == 'close-popup') {
        $('#call-popup').modal('hide');
    }
}

function updatePopup(reservationTaskAttr, twilioClientConnObj) {
    var storeName = "N/A";
    var storePhone = "N/A";
    var ivrOption = "N/A";
    var callerPhone = "N/A";
    var callerName = "N/A";
    var callerLocation = "N/A";
    var storeTitle = '';
    var storeLocation = '';

    if (reservationTaskAttr) {
        if (reservationTaskAttr.to) {
            storePhone = reservationTaskAttr.to;
            var storeInfo = window.storeListJson;

            for (var i = 0; i < storeInfo.length; i++) {
                if (storeInfo[i].twilio_phone == storePhone) {
                    storeName = storeInfo[i].name;
                    storeTitle = storeInfo[i].title;
                    storeLocation = storeInfo[i].location;
                    break;
                }
            }
        }

        //ivrOption = reservationTaskAttr.selected_task_type ? reservationTaskAttr.selected_task_type : ivrOption;
        ivrOption = '';
        getIvrOptionName(reservationTaskAttr.call_sid, reservationTaskAttr.called);

        callerPhone = reservationTaskAttr.from ? reservationTaskAttr.from : callerPhone;
        callerName = reservationTaskAttr.caller_name ? reservationTaskAttr.caller_name : callerName;
        callerLocation = reservationTaskAttr.caller_city && reservationTaskAttr.caller_state ? reservationTaskAttr.caller_city + ', ' + reservationTaskAttr.caller_state : callerLocation;

        if (window.pingPongActive === true) {

            var send = storeLocation ? storeLocation : storeTitle;

            console.log('send to app: ' + send);

            if (send) {
                pingPong.send('twilio-to-app-store-update', send);
                console.log('sent to app: ' + send);
            }
        }
    }

    if (twilioClientConnObj) {
        ivrOption = twilioClientConnObj.ivrOption ? twilioClientConnObj.ivrOption : ivrOption;
        callerPhone = twilioClientConnObj.callerPhone ? twilioClientConnObj.callerPhone : callerPhone;
    }

    $('#call-popup .modal-body li img').hide();
    $('#call-popup .modal-body li.store-name span.text').text(storeName);
    $('#call-popup .modal-body li.store-phone span.text').text(formatPhone(storePhone));
    $('#call-popup .modal-body li.ivr-option span.text').text(ivrOption);
    $('#call-popup .modal-body li.caller-phone span.text').text(formatPhone(callerPhone));
    $('#call-popup .modal-body li.caller-name span.text').text(callerName);
    $('#call-popup .modal-body li.caller-location span.text').text(callerLocation);
}

function formatPhone(number) { // only for US numbers
    number = number ? number.replace(/[^0-9+]/g, '') : number;
    if (!number || number.length < 10) return;

    var phone = number.substr(-10);
    var countryCode = number.substr(0, number.length - 10);

    return (countryCode ? countryCode + ' ' : '') + '(' + phone.substr(0, 3) + ') ' + phone.substr(3, 3) + '-' + phone.substr(6);
}

function getIvrOptionName(callSid, toNumber) {
    $.ajax({
        type: 'POST',
        url: '/store-ivr/get-name-by-call-sid',
        data: {
            callSid: callSid,
            toNumber: toNumber
        },
        success: function (data) {
            $('#call-popup .modal-body li.ivr-option span.text').text(data);
            logger("Selected IVR Option: " + data);
        },
        error: function (data) {
            $('#call-popup .modal-body li.ivr-option span.text').text('N/A');
            logger("Selected IVR Option: " + 'N/A');
        },
        beforeSend: function () {
            $('#call-popup .modal-body li.ivr-option img').show();
        },
        complete: function () {
            $('#call-popup .modal-body li.ivr-option img').hide();
        }
    });
}

// Call transfer --------------------------------------------------

function getCallTransferList(_this) {
    $.ajax({
        type: 'POST',
        url: '/worker/get-call-transfer-list',
        success: function (data) {
            $('#call-transfer-modal .phone-list').html(data);

            if ($(_this).attr('data-type') == 'conference') {
                $('#call-transfer-modal .conference-transfer').show();
            } else {
                $('#call-transfer-modal .direct-transfer').show();
            }

            workspace.workers.fetch({"Available": "1"},
                function (error, workerList) {
                    if (error) {
                        console.log(error.code);
                        console.log(error.message);
                        $('#call-transfer-in-network-tbl').html('<tr><td colspan="4">Some error occurred while fetching list. Please try again.</td><tr>');
                        return;
                    }
                    var row;
                    var data = workerList.data;
                    for (i = 0; i < data.length; i++) {
                        if (!data[i].activityName || ['reserved', 'offline', 'busy', 'wrapup'].indexOf(data[i].activityName.toLowerCase()) !== -1) continue;
                        var phone = data[i].attributes.contact_uri;
                        if (phone && phone.indexOf('client:') === -1) {
                            phone = phone ? phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6) : '';
                        }
                        row += '<tr>';
                        row += '<td>' + data[i].activityName + '</td>';
                        row += '<td>' + data[i].friendlyName + '</td>';
                        row += '<td>' + phone + '</td>';
                        if (phone) {
                            row += '<td>';
                            row += '<button class="btn btn-xs btn-primary" onclick="selectCall(\'' + data[i].attributes.contact_uri + '\', \'in-network\', \'' + data[i].friendlyName + '\')">Select</button>';
                            row += '</td>';
                        } else {
                            row += '<td></td>'
                        }
                        row += '</tr>';
                    }
                    if (row) {
                        $('#call-transfer-in-network-tbl').html(row);
                    } else {
                        $('#call-transfer-in-network-tbl').html('<tr><td colspan="4">No agent available!</td><tr>');
                    }
                }
            );
        },
        error: function (data) {
            var errors = data.responseJSON;
            console.log(errors);
            $('#call-transfer-modal .phone-list').html('<h3>Some error occurred while fetching list. Please try again.</h3>');
        },
        beforeSend: function () {
            $('#call-transfer-modal .to-store .to').attr('data-to', '');
            $('#call-transfer-modal .to-store .to').attr('data-type', '');
            $('#call-transfer-modal .to-store .to').html('Select from the list below');
            $('#call-transfer-modal .direct-transfer').hide();
            $('#call-transfer-modal .conference-transfer').hide();
            $('#call-transfer-modal .phone-list').html('<h3>Please wait...</h3>');
            $('#call-transfer-modal').modal('show');
        }
    });
}

function callTransferSearch(_this) {
    var text = $($(_this).closest('div').find('input')).val();
    if (!text || !text.trim()) {
        $('#call-transfer-out-network-tbl tr').show();
        return;
    }
    var textArray = text.trim().replace(/\s+/g, ' ').toLowerCase().split(' ');

    $('#call-transfer-out-network-tbl tr').each(function () {
        $(this).hide();
        var title = $(this).attr('data-title') ? $(this).attr('data-title').toLowerCase().trim() : '';
        for (var i = 0; i < textArray.length; i++) {
            if (title.indexOf(textArray[i]) !== -1) {
                $(this).show();
            }
        }
    });
}

function callTransferSearchReset(_this) {
    $($(_this).closest('div').find('input')).val('');
    $('#call-transfer-out-network-tbl tr').show();
}

function selectCallCustom(_this) {
    var phone = $($(_this).closest('div').find('input')).val();
    if (!phone || !phone.trim()) {
        alert('Invalid Number');
        return;
    }

    selectCall(phone.trim(), 'out-network', formatPhone(phone.trim()));
}

function selectCall(phone, type, title) {
    $('#call-transfer-modal .to-store .to').attr('data-to', phone);
    $('#call-transfer-modal .to-store .to').attr('data-type', type);
    $('#call-transfer-modal .to-store .to').html(title);
}

function directTransfer(_this) {
    var phone = $('#call-transfer-modal .to-store .to').attr('data-to');
    var type = $('#call-transfer-modal .to-store .to').attr('data-type');

    if (!phone || !type) {
        console.log('directTransfer: Phone and/or type not selected.');
        alert('Please select Store/Agent from the list below.');
        return;
    }

    if (type == 'in-network') {
        workspace.workers.fetch({"Available": "1"},
            function (error, workerList) {
                if (error) {
                    alert('Some error occurred. Please try again.');
                    return;
                }
                var callOk = false;
                var data = workerList.data;
                for (i = 0; i < data.length; i++) {
                    var workerPhone = data[i].attributes.contact_uri;
                    if (workerPhone && workerPhone.indexOf('client:') === -1) {
                        workerPhone = workerPhone ? workerPhone.substring(0, 3) + '-' + workerPhone.substring(3, 6) + '-' + workerPhone.substring(6) : '';
                    }

                    if (phone == workerPhone && data[i].activityName && ['reserved', 'offline', 'busy', 'wrapup'].indexOf(data[i].activityName.toLowerCase()) === -1) {
                        callOk = true;
                        break;
                    }
                }

                if (callOk) {
                    directTransferOK(phone, type);
                } else {
                    alert('Agent is busy or offline. Please try again.');
                    return;
                }
            }
        );
    } else {
        directTransferOK(phone, type);
    }

    function directTransferOK(phone, type) {
        logger('Direct call transfer.');
        console.log('Direct call transfer.');

        $.ajax({
            type: 'POST',
            url: '/worker/transfer-call',
            data: {
                callSid: $('#call_sid').val(),
                phone: phone,
                type: type
            },
            success: function (data) {
                if (data == 1) {
                    $('#call-transfer-modal').modal('hide');
                    agentToAgentTransfer('transfer', null);
                } else {
                    alert('Some error occurred. Please check phone number.');
                }
            },
            error: function (data) {
                console.log(data.responseJSON);
                alert('Some error occurred. Please check phone number.');
            }
        });
    }
}

function conferenceTransfer() {

    var phone = $('#call-transfer-modal .to-store .to').attr('data-to');
    var type = $('#call-transfer-modal .to-store .to').attr('data-type');

    if (!phone || !type) {
        console.log('conferenceTransfer: Phone and/or type not selected.');
        alert('Please select Store/Agent from the list below.');
        return;
    }

    $('#call-transfer-modal').on('hide.bs.modal', function (e) {
        resetConferenceVars();
        Twilio.Device.disconnectAll();
        changeWorkerActivityStatus('WrapUp', function() {
            console.log('conferenceTransfer: Modal Close ');
        });
    });

    // Put customer on hold i.e. get current call's sid ( $('#call_sid').val() ) and redirect it to play twiml. Set conferencePhoneTransferCallSid & conferencePhoneTransfer variables.
        // As soon as current call's sid is put on hold, worker's activity will change to 'Wrapup' as defined in CallRouteController.php >> agentAnswer >> postWorkActivitySid.
        // So, "registerTaskRouterCallbacks >> worker.on('activity.update'" will be called by Twilio
        // By default it creates timer for "Change activity from Wrapup to Idle ( setTimeout(changeWorkerAvailable, 20000) )"
        // but for conference transfer, we will change activity to "Busy" by using window.conferencePhoneTransfer. Check "registerTaskRouterCallbacks >> worker.on('activity.update'"

    $.ajax({
        type: 'POST',
        url: '/worker/reset-conference-transfer-participant',
        data: {
            conferenceId: $('#call_sid').val(),
            customerCallSid: $('#call_sid').val()
        },
        beforeSend: function() {
            resetConferenceVars();
            $('#call-transfer-modal .conference-transfer .store-conference-connect').attr('disabled', true);
        },
        success: function (data) {
            if (data == 1) {
                console.log('conferenceTransfer: Success');

                window.conferencePhoneTransferCallSid = $('#call_sid').val();
                window.conferencePhoneTransfer = 1; // 1: customer on hold; 2: conference call initiated
                window.conferencePhoneTransferNumber = phone;

                $('#call-transfer-modal .conference-transfer .customer-hold').hide();
                $('#call-transfer-modal .conference-transfer .customer-connect').show();
                $('#call-transfer-modal .conference-transfer .customer-status').html('On Hold');

                Twilio.Device.disconnectAll();
                window.setTimeout(function() {startTransferConference();}, 3000);

            } else {
                console.log('customerHoldWhileTransfer: Failed');
                alert('Some error occurred. Please try again.');
                $('#call-transfer-modal .conference-transfer .store-conference-btn').attr('disabled', false);
            }
        },
        error: function (data) {
            console.log('customerHoldWhileTransfer: Failed - ' + data.responseJSON);
            alert('Some error occurred. Please try again.');
            $('#call-transfer-modal .conference-transfer .store-conference-btn').attr('disabled', false);
        }
    });
}

function resetConferenceVars() {
    window.conferencePhoneTransferCallSid = null;
    window.conferencePhoneTransfer = 0;
    window.conferencePhoneTransferNumber = null;
    $('#call-transfer-modal .conference-transfer .customer-hold').hide();
    $('#call-transfer-modal .conference-transfer .customer-connect').hide();
    $('#call-transfer-modal .conference-transfer .caller-exit-conference').hide();
    $('#call-transfer-modal .conference-transfer .store-conference-btn').attr('disabled', false);
    $('#call-transfer-modal .conference-transfer .store-conference-connect').show();
    $('#call-transfer-modal .conference-transfer .store-conference-disconnect').hide();
    $('#call-transfer-modal .conference-transfer .customer-status').html('N/A');
    $('#call-transfer-modal .conference-transfer .store-status').html('N/A');
}

function putCustomerOnHold() {
    $.ajax({
        type: 'POST',
        url: '/worker/put-on-hold-by-callsid',
        data: {
            callSid: window.conferencePhoneTransferCallSid
        },
        success: function (data) {
            if (data == 1) {
                console.log('customerHoldWhileTransfer: Success');
                $('#call-transfer-modal .conference-transfer .customer-hold').hide();
                $('#call-transfer-modal .conference-transfer .customer-connect').show();
                $('#call-transfer-modal .conference-transfer .customer-status').html('On Hold');
                $('#call-transfer-modal .conference-transfer .caller-exit-conference').hide();
            } else if (data == 2) {
                console.log('addCustomerToConference: customer hanged up');
                $('#call-transfer-modal .conference-transfer .caller-exit-conference').show();
                alert('Customer hanged up.');
            }  else {
                console.log('customerHoldWhileTransfer: Failed');
                alert('Some error occurred. Please try again.');
            }
        },
        error: function (data) {
            console.log('customerHoldWhileTransfer: Failed - ' + data.responseJSON);
            alert('Some error occurred. Please try again.');
        }
    });
}

function startTransferConference() {

    window.conferencePhoneTransfer = 2;  // 1: customer on hold; 2: conference call initiated;

    Twilio.Device.connect({
        'conferenceTransferCall' : true,
        'conferenceId' : window.conferencePhoneTransferCallSid,
        'customerCallSid' : window.conferencePhoneTransferCallSid,
        'callTo' : window.conferencePhoneTransferNumber
    });
}

function addCustomerToConference() {
    $.ajax({
        type: 'POST',
        url: '/worker/add-customer-to-conference-by-callsid',
        data: {
            callSid: window.conferencePhoneTransferCallSid,
            conferenceId: window.conferencePhoneTransferCallSid,
            endConferenceOnExit: false
        },
        success: function (data) {
            if (data == 1) {
                console.log('addCustomerToConference: Success');
                $('#call-transfer-modal .conference-transfer .customer-connect').hide();
                $('#call-transfer-modal .conference-transfer .customer-hold').show();
                $('#call-transfer-modal .conference-transfer .customer-status').html('Connected');
                $('#call-transfer-modal .conference-transfer .caller-exit-conference').show();
            } else if (data == 2) {
                console.log('addCustomerToConference: customer hanged up');
                $('#call-transfer-modal .conference-transfer .caller-exit-conference').show();
                alert('Customer hanged up.');
            } else {
                console.log('addCustomerToConference: Failed');
                alert('Some error occurred. Please try again.');
            }
        },
        error: function (data) {
            console.log(data.responseJSON);
            console.log('addCustomerToConference: Failed');
            alert('Some error occurred. Please try again.');
        }
    });
}

function callerExitConference() {
    if (confirm('Are you sure you want to exit this conference? Make sure that caller is not on hold.')) {
        conferenceTransferDisconnect('caller', function() {
            $('#call-transfer-modal').modal('hide')
        });
    }
}

function storeExitConference() {
    if (confirm('Are you sure?')) {
        conferenceTransferDisconnect('store', function() {
            $('#call-transfer-modal .conference-transfer .store-status').html('Not Connected');
            $('#call-transfer-modal .conference-transfer .store-conference-disconnect').hide();
        });
    }
}

function conferenceTransferDisconnect(hangup, callbackFunc) {
    $.ajax({
        type: 'POST',
        url: '/worker/hang-up-conference-transfer-participant',
        data: {
            hangup: hangup,
            conferenceId: window.conferencePhoneTransferCallSid
        },
        success: function (data) {
            if (data == 1) {
                console.log('conferenceTransferDisconnect: Success');
                if (callbackFunc && typeof callbackFunc === 'function') {
                    callbackFunc();
                }
            } else if (data == 2) {
                console.log('conferenceTransferDisconnect: No Call Sid');
                alert('Call not yet added to the conference. So cannot be disconnected');
            } else {
                console.log('conferenceTransferDisconnect: Failed');
                alert('Some error occurred. Please try again.');
            }
        },
        error: function (data) {
            console.log(data.responseJSON);
            console.log('conferenceTransferDisconnect: Failed');
            alert('Some error occurred. Please try again.');
        }
    });
}

function conferenceCall(status, conn) {
    console.log('conferenceCall status: ' + status);
    console.log('conferenceCall: ' + (conn && conn.parameters ? JSON.stringify(conn.parameters) : 'N/A'));

    if (status == 'disconnected') {

        $('#call-transfer-modal .conference-transfer .store-conference-connect').attr('disabled', false);
        $('#call-transfer-modal .conference-transfer .store-status').html('Disconnected');

    } else if (status == 'cancelled') {

        $('#call-transfer-modal .conference-transfer .store-conference-connect').attr('disabled', false);
        $('#call-transfer-modal .conference-transfer .store-status').html('Cancelled');

    } else if (status == 'error') {

        $('#call-transfer-modal .conference-transfer .store-conference-connect').attr('disabled', false);
        $('#call-transfer-modal .conference-transfer .store-status').html('Error');

    } else if (status == 'connected') {

        $('#call-transfer-modal .conference-transfer .store-conference-connect').attr('disabled', false);
        $('#call-transfer-modal .conference-transfer .store-conference-disconnect').show();
        $('#call-transfer-modal .conference-transfer .store-status').html('Connected');

    }
}

// Call transfer --------------------------------------------------

function idleTimer() {
    var t, offlineActivitySid;
    window.onload = resetTimer;
    window.onmousemove = resetTimer; // catches mouse movements
    window.onmousedown = resetTimer; // catches mouse movements
    window.onclick = resetTimer;     // catches mouse clicks
    window.onscroll = resetTimer;    // catches scrolling
    window.onkeypress = resetTimer;  //catches keyboard actions

    var activitySids = {};
    worker.activities.fetch(function (error, activityList) {
        var activities = activityList.data;
        var i = activities.length;
        while (i--) {
            activitySids[activities[i].friendlyName] = activities[i].sid;
        }
    });

    function updateWorkerActivity() {
        if (worker.activityName != 'Reserved' && worker.activityName != 'Busy') {
            //worker.update("ActivitySid", activitySids['Offline']);
            changeWorkerActivityStatus('Offline', function() {});
        }
    }

    function resetTimer() {
        clearTimeout(t);
        t = setTimeout(updateWorkerActivity, 3600000);  // time is in milliseconds (1000 is 1 second)
    }
}

var connection = null;

function setupTwilioClient() {
    var answerButton = $(".answer-button");
    var hangUpButton = $(".hangup-button");
    var mute = $('.mute');

    $.post("/worker/token", {workerSid: worker.workerSid}, function (data) {
        if (data.token != '') {
            // Set up the Twilio Client Device with the token
            console.log('data.token: ' + data.token);
            Twilio.Device.setup(data.token);
        } else {
            answerButton.hide();
            hangUpButton.hide();
            mute.hide();
            $('.alert > p').css('padding-bottom', '0px');
        }
    });

    /* Callback to let us know Twilio Client is ready */
    Twilio.Device.ready(function (device) {
        logger("Ready");
        console.log('Twilio.Device Ready');
    });

    /* Report any errors to the call status display */
    Twilio.Device.error(function (error) {
        console.log('Twilio.Device error: ');
        console.log(error);

        if (window.incomingAgentToAgentCall) {
            console.log('Twilio.Device error: agentToAgentCall');
            agentToAgentCall('error', null);
        }

        if (window.incomingAgentToAgentTransfer) {
            console.log('Twilio.Device error: agentToAgentTransfer');
            agentToAgentTransfer('error', null);
        }

        if (window.conferencePhoneTransfer >= 2) {
            console.log('Twilio.Device error: conferencePhoneTransfer');
            conferenceCall('error', null);
        }

        window.incomingAgentToAgentCall = false;
        window.incomingAgentToAgentTransfer = false;
    });

    /* Callback for when Twilio Client initiates a new connection */
    Twilio.Device.connect(function (conn) {
        console.log('Twilio.Device connect: ' + JSON.stringify(conn.parameters));

        // Enable the hang up button and disable the call buttons
        hangUpButton.prop("disabled", false);
        mute.prop("disabled", false);
        answerButton.prop("disabled", true);
        connection = conn;

        if (window.incomingAgentToAgentTransfer) {
            console.log('Twilio.Device connected: agentToAgentTransfer');
            agentToAgentTransfer('connected', conn);
        }

        if (window.conferencePhoneTransfer >= 2) {
            console.log('Twilio.Device connect: conferencePhoneTransfer');
            conferenceCall('connected', conn);
        }

        logger("Successfully established call");
    });

    /* Callback for when a call ends */
    Twilio.Device.disconnect(function (conn) {
        console.log('Twilio.Device disconnect: ' + JSON.stringify(conn.parameters));

        // Disable the hangup button and enable the call buttons
        hangUpButton.prop("disabled", true);
        mute.prop("disabled", true);

        if (window.incomingAgentToAgentCall) {
            console.log('Twilio.Device disconnect: agentToAgentCall');
            agentToAgentCall('disconnected', null);
        }

        if (window.incomingAgentToAgentTransfer) {
            console.log('Twilio.Device disconnect: agentToAgentTransfer');
            agentToAgentTransfer('disconnected', conn);
        }

        if (window.conferencePhoneTransfer >= 2) {
            console.log('Twilio.Device disconnect: conferencePhoneTransfer');
            conferenceCall('disconnected', conn);
        }

        window.incomingAgentToAgentCall = false;
        window.incomingAgentToAgentTransfer = false;

        logger("Call ended.");
    });

    /* Callback for when Twilio Client receives a new incoming call */
    Twilio.Device.incoming(function (conn) {
        console.log('Twilio.Device incoming: ' + JSON.stringify(conn.parameters));

        if (conn.parameters && conn.parameters.From && conn.parameters.From.indexOf('client:') != -1 && conn.parameters.To && conn.parameters.To.indexOf('client:') != -1) {
            console.log('Twilio.Device incoming: agentToAgentCall');
            window.incomingAgentToAgentCall = true;
            agentToAgentCall('incoming', conn);
        } else {
            // Set the reference to the current
            // connection when we receive an
            // incoming call
            connection = conn;

            answerButton.prop("disabled", false);

            // Clear the reference to the
            // connection when disconnected.
            connection.disconnect(function () {
                connection = null;
            });

            if (window.currentActivity.toLowerCase() == 'idle') {
                console.log('Twilio.Device incoming: agentToAgentTransfer');
                window.incomingAgentToAgentTransfer = true;
                agentToAgentTransfer('incoming', conn);
            }
        }
    });

    /* Callback for when incoming call gets cancelled */
    Twilio.Device.cancel(function (conn) {
        console.log('Twilio.Device cancel: ' + JSON.stringify(conn.parameters));

        if (window.incomingAgentToAgentCall) {
            console.log('Twilio.Device cancel: agentToAgentCall');
            agentToAgentCall('cancelled', null);
        }

        if (window.incomingAgentToAgentTransfer) {
            console.log('Twilio.Device cancel: agentToAgentTransfer');
            agentToAgentTransfer('cancelled', conn);
        }

        if (window.conferencePhoneTransfer >= 2) {
            console.log('Twilio.Device cancel: conferencePhoneTransfer');
            conferenceCall('cancelled', conn);
        }

        window.incomingAgentToAgentCall = false;
        window.incomingAgentToAgentTransfer = false;

        logger("Incoming Call Cancelled.");
    });

    // Set a callback on the answer button and enable it
    answerButton.click(function () {
        connection.accept();
    });
}

/* End a call */
function hangUp() {
    Twilio.Device.disconnectAll();
}

function mute() {
    if (connection.isMuted()) {
        $('.mute span').text('Mute');
        $('.mute').find('i').removeClass('fa-microphone');
        $('.mute').find('i').addClass('fa-microphone-slash');
        connection.mute(false);
    } else {
        $('.mute span').text('Unmute');
        $('.mute').find('i').removeClass('fa-microphone-slash');
        $('.mute').find('i').addClass('fa-microphone');
        connection.mute(true);
    }
}

function agentToAgentCall(status, conn) {
    console.log('agentToAgentCall status: ' + status);
    console.log('agentToAgentCall: ' + (conn && conn.parameters ? JSON.stringify(conn.parameters) : 'N/A'));

    var answer = $('#agent-to-agent-call .answer-btn');
    var mute = $('#agent-to-agent-call .mute-btn');
    var hangup = $('#agent-to-agent-call .hangup-btn');
    var callStatusWrapper = $('#agent-to-agent-call .status-wrapper');
    var callStatus = $('#agent-to-agent-call .status');
    var callTimer = $('#agent-to-agent-call .timer');

    if (status == 'incoming') {

        changeWorkerActivityStatus('Busy', function() {
            answer.prop("disabled", false);
            mute.prop("disabled", true);
            hangup.prop("disabled", false);

            answer.unbind();
            answer.on('click', function () {
                conn.accept();
                answer.prop("disabled", true);
                mute.prop("disabled", false);
                hangup.prop("disabled", false);
                agentToAgentCallLog(conn.parameters.From, 'Answered Call From: ', 2, callStatus);

                window.outboundCallStart = moment.utc();
                window.outboundCallTimer = setInterval(function () {
                    callTimer.html(moment.utc(moment().diff(window.outboundCallStart)).format('HH:mm:ss'));
                }, 1000);

                hangup.unbind();
                hangup.on('click', function () {
                    clearTimeout(window.outboundCallTimer);
                    agentToAgentCallLog(conn.parameters.From, 'Hanged Up Call From: ', 1, callStatus);
                    conn.disconnect();
                    changeWorkerActivityStatus('Idle');
                    $('#agent-to-agent-call').modal('hide');
                });
            });

            mute.unbind();
            mute.on('click', function () {
                if (conn.isMuted()) {
                    mute.find('span').text('Mute');
                    mute.find('i').removeClass('fa-microphone');
                    mute.find('i').addClass('fa-microphone-slash');
                    conn.mute(false);
                    agentToAgentCallLog(conn.parameters.From, 'Unmuted Call From: ', 1, callStatus);
                } else {
                    mute.find('span').text('Unmute');
                    mute.find('i').removeClass('fa-microphone-slash');
                    mute.find('i').addClass('fa-microphone');
                    conn.mute(true);
                    agentToAgentCallLog(conn.parameters.From, 'Muted Call From: ', 1, callStatus);
                }
            });

            hangup.unbind();
            hangup.on('click', function () {
                clearTimeout(window.outboundCallTimer);
                agentToAgentCallLog(conn.parameters.From, 'Rejected Call From: ', 1, callStatus);
                conn.reject();
                changeWorkerActivityStatus('Idle');
                $('#agent-to-agent-call').modal('hide');
            });

            agentToAgentCallLog(conn.parameters.From, 'Call From: ', 2, callStatus);
            callStatusWrapper.show();

            $('#agent-to-agent-call').modal('show');
        });

    } else {
        changeWorkerActivityStatus('Idle', function() {
            $('#agent-to-agent-call').modal('hide');
        });
    }

}

function agentToAgentTransfer(status, conn) {
    console.log('agentToAgentTransfer status: ' + status);
    console.log('agentToAgentTransfer: ' + (conn && conn.parameters ? JSON.stringify(conn.parameters) : 'N/A'));

    if (status == 'incoming') {
        changeWorkerActivityStatus('Reserved', function() {
            popup('Reserved');
            $('.transfer-call-btn').hide();
            logger("Incoming Call: " + conn.parameters.CallSid);
            window.setTimeout(function() {
                var obj = {};
                obj.ivrOption = "Transferred Call";
                obj.callerPhone = conn.parameters.From;
                updatePopup(null, obj);
            }, 3000);
        });

    } else if (status == 'disconnected') {
        changeWorkerActivityStatus('WrapUp', function() {
            logger('Incoming Call: ' + status);
        });
    } else if (status == 'transfer') {
        changeWorkerActivityStatus('WrapUp', function() {
            logger('Call transferred');
        });
    } else if (status == 'cancelled' || status == 'error') {
        changeWorkerActivityStatus('Idle', function() {
            popup('close-popup');
            logger('Incoming Call: ' + status);
        });
    } else if (status == 'connected') {
        changeWorkerActivityStatus('Busy', function() {
            popup('Busy');
            $('.wrapup > .change-activity').hide();
            $('#caller_id').text(conn.parameters.From);
            $('#call_sid').val(conn.parameters.CallSid);
            $('.feedback').show();
            var obj = {};
            obj.ivrOption = "Transferred Call";
            obj.callerPhone = conn.parameters.From;
            updatePopup(null, obj);
            logger('Incoming Call: ' + conn.parameters.CallSid + ' accepted!');
        });
    }
}

function agentToAgentCallLog(from, msg, type, callStatusElem) {
    from = window.workerDetails.hasOwnProperty(from) ? window.workerDetails[from] : from;

    logger(msg + from + '. Time: ' + moment().format('LTS'));

    if (type == 2) {
        callStatusElem.html(msg + from);
    }
}

function changeWorkerActivityStatus(status, callbackFunc) {
    console.log('changeWorkerActivityStatus Change from, to: ' + window.currentActivity + ', ' + status);
    console.log('changeWorkerActivityStatus: Check if there is any pending reservation.');

    var queryParams = {"ReservationStatus":"pending"};
    worker.fetchReservations(
        function(error, reservations) {
            var updateOk = true;

            if(error) {
                console.log(error.code);
                console.log(error.message);
            } else {
                var data = reservations.data;
                for(i = 0; i < data.length; i++) {
                    console.log(data[i].sid);
                    updateOk = false;
                }
            }

            if (updateOk) {
                console.log('Worker HAS NOT any pending reservation. OK to change status to ' + status);
                if (window.workerActivitySidList && window.workerActivitySidList.hasOwnProperty(status)) {
                    worker.update('ActivitySid', window.workerActivitySidList[status]);
                    if (typeof callbackFunc === 'function') {
                        callbackFunc();
                    }
                }
            } else {
                console.log('Worker HAS pending reservation. NOT OK to change status to ' + status);
            }
        },
        queryParams
    );
}

function outboundCallInit(_this) {
    if (window.currentActivity != 'Offline') {
        alert('You must be Offline to make outbound calls.');
        return;
    }

    $('#outbound-call-modal .modal-body #iframe').hide();
    $('#outbound-call-modal .modal-body #iframe').unbind();

    $('#outbound-call-modal .modal-body #iframe').on('load', function() {
        console.log('Outbound call iframe loaded!');
        $('#outbound-call-modal .modal-body .loading').empty();
        $('#outbound-call-modal .modal-body #iframe').show();
    });


    $('#outbound-call-modal .modal-body .loading').html('Loading...');
    $('#outbound-call-modal .modal-body #iframe').attr('src', window.outboundCallUrl);

    $('#outbound-call-modal').on('hidden.bs.modal', function (e) {

    });

    $('#outbound-call-modal').modal('show');
}

window.onload = function () {

    // Initialize TaskRouter.js on page load using window.workerToken -
    // a Twilio Capability token that was set in a &lt;script> in agent.php
    if (document.getElementById('log') != undefined) {
        logger("Initializing...");
        window.worker = new Twilio.TaskRouter.Worker(workerToken);
        window.workspace = new Twilio.TaskRouter.Workspace(workspaceToken);
        window.storeListJson = JSON.parse(window.storeList.replace(/&quot;/g, '"'));
        window.currentActivity = 'Idle';
        window.incomingAgentToAgentCall = false;
        window.incomingAgentToAgentTransfer = false;
        //window.agentToAgentTransferCallActive = false;
        window.conferencePhoneTransferCallSid = null;
        window.conferencePhoneTransferActive = 0;
        window.conferencePhoneTransferNumber = null;
        registerTaskRouterCallbacks();
        bindAgentActivityButtons();
        setupTwilioClient();
        idleTimer();

        window.workerDetails = {};

        workspace.workers.fetch(
            function (error, workerList) {
                if (error) {
                    console.log(error.code);
                    console.log(error.message);
                } else {
                    var data = workerList.data;
                    for (i = 0; i < data.length; i++) {
                        window.workerDetails[data[i].attributes.contact_uri] = data[i].friendlyName;
                    }
                }
            }
        );

        window.workerActivitySidList = {};

        worker.activities.fetch(function (error, activityList) {
            if (error) {
                console.log('onload worker.activities.fetch: ' + error.code);
                console.log('onload worker.activities.fetch: ' + error.message);
                alert('Some error occurred while loading. Please reload the page.')
            } else {
                var activities = activityList.data;
                var i = activities.length;
                while (i--) {
                    window.workerActivitySidList[activities[i].friendlyName] = activities[i].sid;
                }
            }
        });
    }

    if (window.pingPongActive === true) {
        pingPong.init({});
        console.log('Pingpong init OK');
    }

};
